import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhuye",
  "use": "icon-zhuye-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zhuye\"><path d=\"M156.438 550.562V960.23h246.174V683.47H618.63v276.76h246.633V550.563h137.01L510.849 66.444 18.971 550.563zm868.213 302.35\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol